var render, staticRenderFns
import script from "./KycImageThumb.vue?vue&type=script&lang=js"
export * from "./KycImageThumb.vue?vue&type=script&lang=js"
import style0 from "./KycImageThumb.vue?vue&type=style&index=0&id=399fe47f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399fe47f",
  null
  
)

export default component.exports